<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-08 18:53:23
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-19 10:48:53
 * @FilePath: /chaoyongtuan/src/components/shopNameSelect/shopNameSelect.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-select
		:loading="loading"
		v-model="searchValue"
		class="select-box"
		filterable
		clearable
		default-first-option
		placeholder="请输入店铺名称"
		@change="changeSelect"
		:filter-method="remoteMethodList"
		@visible-change="onVisibleChange"
		@focus="handleFocus"
		v-scroll-lazy-load="{
			loadData: shopLoadData,
			distance: 50,
			delay: 300,
			scrollBody: '.el-scrollbar__wrap',
			callback: fn => this.$once('hook:beforeDestroy', () => fn()),
		}"
	>
		<el-option v-for="item in list" :key="item.outer_shop_id" :label="item.shop_name" :value="item.outer_shop_id" />
		<div class="align-center bottom pt-8 pb-8 yx-color-text-secondary fz-12">
			{{ !pageHas ? '到底了~' : '加载中' }}
		</div>
	</el-select>
</template>
<script>
import { getCooperativeShop } from '@/api/cooperativeShop';
import { getShopList } from '@/api/shopManage';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		source: {
			type: String,
			default: 'goods',
		},
		passive: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			list: [],
			searchValue: '',
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			pageHas: true,
			keyword: '',
			loading: false,
			emitObj: {},
		};
	},
	methods: {
		clear() {
			this.searchValue = '';
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.pageHas = true;
			this.keyword = '';
			this.loading = false;
			this.emitObj = {};
			this.getList();
		},
		async getList(e) {
			try {
				const { platformId: platform_id, pageInfo } = this;
				const api = this.source === 'goods' ? getCooperativeShop : getShopList;
				const { list = [], page = {} } = await api({ ...pageInfo, shop_name: e, platform_id });
				this.list = this.list.concat(list);
				this.total = `${page.item_total}`;
				this.pageHas = page.page_has;
			} finally {
				this.loading = false;
			}
		},
		//用于默认选择某个店铺 外面用
		async initShop(row) {
			if (row.shop_name && row.shop_id) {
				await this.remoteMethodList(row.shop_name);
				this.changeSelect(row.shop_id);
				this.searchValue = row.shop_id;
			} else {
				this.remoteMethodList();
			}
		},
		async remoteMethodList(e) {
			if (e == this.keyword) {
				return;
			}
			try {
				this.loading = true;
				const { platformId: platform_id, pageInfo } = this;
				this.list = [];
				this.keyword = e;
				pageInfo.page_index = 1;
				const api = this.source === 'goods' ? getCooperativeShop : getShopList;
				const { list = [], page = {} } = await api({ ...pageInfo, shop_name: e, platform_id });
				this.list = list;
				this.total = `${page.item_total}`;
				this.pageHas = page.page_has;
				if (!list.length) {
					this.emitObj = {};
				}
			} finally {
				this.loading = false;
			}
		},
		changeSelect(val) {
			let filterList = this.list.filter(item => item.outer_shop_id == val);
			this.emitObj = {
				shop_name: filterList[0]?.shop_name || '',
				outer_shop_id: filterList[0]?.outer_shop_id || '',
			};
			this.$emit('change', this.emitObj);
			this.$emit('input', filterList[0]?.outer_shop_id);
		},
		onVisibleChange() {
			if (this.searchValue === '') {
				this.remoteMethodList('');
			}
		},
		shopLoadData() {
			if (!this.pageHas) {
				return;
			}
			this.pageInfo.page_index++;
			this.getList(this.keyword);
		},
		handleFocus() {
			if (this.passive && !this.list.length) {
				this.getList();
			}
		},
	},
	created() {
		!this.passive && this.getList();
	},
};
</script>
